import { getNextKey } from 'util/id'

export class MessageStore {
  readonly key = getNextKey()
  readonly text: string

  constructor(text: string) {
    this.text = text
  }
}
